import store from '@/config/vuex'
import { NEW_RELIC_EVENTS, NEW_RELIC_LOGGING_EVENT } from './constants'

function getAdditionalContextFromStore() {
  const locale = store.getters['page/locale']?.split('-')
  const user = store.getters['account/currentUser']
  const taxTotal = store.getters['order/taxTotal']
  const total = store.getters['order/total']

  return {
    country_iso_code: locale?.[1] || '',
    currency_iso_code: store?.state?.store?.currency?.code || '',
    order_number: store.state?.order?.number || '',
    order_tax_amount: taxTotal,
    order_total_amount: total,
    user_id: user?.id,
  }
}

function eventData({ error, ...rest }) {
  return {
    flow: NEW_RELIC_LOGGING_EVENT.orderToCash,
    is_successful: !error,
    additional_context: {
      ...getAdditionalContextFromStore(),
      ...rest,
      error_code: null,
      error_message: error,
    },
  }
}

export const events = {
  [NEW_RELIC_EVENTS.addPromoCode]: ({ error = null, promoCode }) =>
    eventData({
      error,
      coupon_code: promoCode,
    }),
  [NEW_RELIC_EVENTS.completePayment]: ({ error = null, paymentAmount }) =>
    eventData({
      error,
      payment_amount: paymentAmount,
    }),
  [NEW_RELIC_EVENTS.removePromoCode]: ({ error = null, promoCode }) =>
    eventData({
      error,
      coupon_code: promoCode,
    }),
  [NEW_RELIC_EVENTS.submitBillingAddress]: ({ error = null }) =>
    eventData({
      error,
    }),
  [NEW_RELIC_EVENTS.submitPayment]: ({ error = null }) =>
    eventData({
      error,
    }),
  [NEW_RELIC_EVENTS.submitShippingAddress]: ({ error = null }) =>
    eventData({
      error,
    }),
  [NEW_RELIC_EVENTS.submitShippingMethod]: ({ error = null, shippingMethodCode }) =>
    eventData({
      error,
      shipping_method_code: shippingMethodCode,
    }),
}
